import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';

export const useReturnTypeDisplay = () => {
  const { t } = useTranslate();

  return useMemoizedFn((returnType: Conversation.Trade.IReturnType) => {
    const returnTypeMap = {
      ONLY_REFUND: t('domain.returnRefund.type.refundOnly'),
      RETURN_REFUND: t('domain.returnRefund.type.returnRefund'),
      CHANGE: t('scene.orderWorkspace.returnRefundTab.list.returnType.exchange'),
    };
    return returnTypeMap[returnType] ?? t('domain.returnRefund.type.returnRefund');
  });
};
